import { render } from "./CurrentProfilesIndex.vue?vue&type=template&id=2f9e4834"
import script from "./CurrentProfilesIndex.vue?vue&type=script&lang=js"
export * from "./CurrentProfilesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__